import { render, staticRenderFns } from "./CustomAmount.vue?vue&type=template&id=f966cbfa&"
import script from "./CustomAmount.vue?vue&type=script&lang=js&"
export * from "./CustomAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports